import React, { memo, useCallback } from 'react'
import Profile from '../../components/account/Profile'
import SettingsPanel from '../../components/settings/SettingsPanel'
import LOG from '../../logging/Logger'

const SettingsAccountProfile = memo(({ toggleDrawer, logout }) => {
  LOG.debug('Render: SettingsAccountProfile')

  const handleSignOut = useCallback(async () => {
    toggleDrawer()
    await logout()
  }, [logout, toggleDrawer])

  return (
    <SettingsPanel title='Profile'>
      <Profile signOut={handleSignOut} />
    </SettingsPanel>
  )
})

export default SettingsAccountProfile
